import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../../styles/components/tableOverlay.module.scss';

const TableNoRowsMessage = () => {
  const { t, ready } = useTranslation(['datagrid']);
  const message = ready ? t(`datagrid:noRows`) : '';

  return <h2 className={styles.message}>{message}</h2>;
};

export default TableNoRowsMessage;
